import React, { useContext } from 'react';

import Profile from './Profile';
import Account from './Account';
import Invoices from './Invoices';
import Offices from './Offices';
import Users from './Users';
import type { RouteComponentProps } from '@gatsbyjs/reach-router';

import Wallet from './Wallet';
import useUserRights from '~/hooks/useUserRights';
import SubscriptionSettings from './Subscription';
import Brand from './Brand';
import Widget from '../Widget';
import DHRouter from '~/components/atom/DHRouter';
import NotFound from '../404';
import LFASettings from './LFASettings';
import { AuthContext } from '~/Root/Auth';

const SettingsPage: React.FCC<RouteComponentProps> = () => {
  const { isDHAdmin } = useContext(AuthContext);
  const { view: mayViewSubscription } = useUserRights({
    category: 'Subscription',
  });

  return (
    <DHRouter>
      <Profile path="/profile/*" />
      <Offices path="/offices/*" />
      <Users path="/users/*" />
      <Account path="/account/*" />
      <Brand path="/brand/*" />
      {mayViewSubscription && <SubscriptionSettings path="/subscription/*" />}
      <Invoices path="/invoices/*" />
      <Wallet path="/wallet/*" />
      <Widget path="/widget/*" />
      {isDHAdmin && <LFASettings path="/lfa/*" />}
      <NotFound default />
    </DHRouter>
  );
};

export default SettingsPage;
